import { ActionTypes } from '../actions/types';
import { ServiceModel } from '../../models/ServiceModel';
import { Auftrag, Auftragsposition } from '../../api';
import {
  ABWEICHENDE_BELADESTELLE,
  ABWEICHENDE_ENTLADESTELLE,
  ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER,
  ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER,
  addAdresseTypToAdresse,
  EMPFAENGER,
  emptyAdresse,
  findAdresseByTyp,
  initAdressen,
  NACHNAHME_EMPFAENGER,
  NEUTRALE_ABSENDERADRESSE,
  replaceAdresseByTyp,
  VERSENDER,
} from '../../layouts/tms/auftragserfassung/adresse/AdresseTypen';
import { StateModel_Auftragserfassung } from '../store';
import { AuftragPositionModel } from '../../models/AuftragPositionModel';
import { toSelectOption } from '../../components/select/SelectModel';
import { isoDateToDate, nextWorkingDay } from '../../utils/date';
import { getServiceInitialListe } from '../../layouts/tms/auftragserfassung/services/DefaultServices';
import { ConfigModel } from '../../models/ConfigModel';
import { isoDateToTime } from '../../utils/time';

const initialState: StateModel_Auftragserfassung = {
  adressen: initAdressen(),
  currentServices: getServiceInitialListe() /* []*/,
  currentAuftragpos: [],
  currentZusLademittel: [],
  resetToggle: false, // Wert ist egal, hauptsache, er ändert sich, damit useEffect getriggert wird
  suchvorschlaege: [],
  id: undefined,
  copyId: undefined,
  vorlageAuftragId: undefined,
  spedeigennr: undefined,
  datum: undefined,
  beladedatum: isoDateToDate(new Date()),
  beladezeitVon: undefined,
  beladezeitBis: undefined,
  empfaengerreferenz: undefined,
  partnerreferenz: undefined,
  entladedatum: isoDateToDate(new Date(nextWorkingDay())),
  mandant: undefined,
  entladezeitVon: undefined,
  entladezeitBis: undefined,
  absenderreferenz: undefined,
  mitGefahrguetern: undefined,
  terminkennzeichen: undefined,
  zustellkennzeichen: undefined,
  anlieferkennzeichen: undefined,
  frankatur: 5,
  verkehrsart: 1,
  metrokennung: undefined,
  sperrigkeit: undefined,
  iban: undefined,
  bic: undefined,
  nachnahmeBetrag: undefined,
  nachnahmeWaehrung: undefined,
  status: undefined,
  tauschpaletteA: undefined,
  tauschpaletteB: undefined,
  tauschpaletteR: undefined,
  tauschpaletteY: undefined,
  hinweis: undefined,
  dispohinweis: undefined,
  zollvermerk: undefined,
  abtragen: undefined,
  lenkeravis: undefined,
  myDelivery: undefined,
  adv3: undefined,
  currentControlling: undefined,
  empfaengerReferenz: undefined,
  reports: [],
  isCreateAbsender: false,
  isCreateEmpfaenger: false,
  kf_id: undefined,
  berechnteile: [],
  abweichendeBeladung: false,
  neutralerAbsenderAdresse: undefined,
  isNeutralerAbsenderAdresse: false,
  isAbweichendeBeladeAdresse: false,
  spotpreisnr: undefined,
  erfasser: undefined,
  aenderer: undefined,
  currentBenutzer: undefined,
  datumErfasst: undefined,
  datumgeaendert: undefined,
  auftragServices: [], //#84367
};

const createServices = (
  services: ServiceModel[],
  auftrag: Auftrag
): ServiceModel[] => {
  const temp = [...services];

  temp.forEach(service => {
    if (service.attributName === 'mitGefahrguetern') {
      service.active = auftrag.mitGefahrguetern ?? false;
    }
    if (service.attributName === 'lenkeravis') {
      service.active = auftrag.lenkeravis ?? false;
    }
    if (service.attributName === 'abtragen') {
      service.active = auftrag.abtragen ?? false;
    }
    if (service.attributName === 'myDelivery') {
      service.active = auftrag.myDelivery ?? false;
    }
    if (service.attributName === 'adv3') {
      service.active = auftrag.adv3 ?? false;
    }

    const dynamic = auftrag.auftragServices;
    if (dynamic) {
      dynamic.forEach(dynservice => {
        const id = dynservice.id;
        const spez_Num = dynservice.spez_num;
        const wert = dynservice.wert;
        if (service.spez_num === spez_Num) {
          service.active = false;
          if (wert && wert != 'null' && wert.trim().length > 0) {
            if (service.isAWSperre && wert.trim().toLowerCase() != 'false') {
              service.isAWSperre = false;
            }
          }
          if (service.typ?.trim().toLowerCase() === 'logisch') {
            if (wert && wert.trim().toLowerCase() === 'true') {
              service.active = true;
            }
          } else if (wert && wert.trim().toLowerCase() != 'null') {
            service.wert = wert;
          }
        }
      });
    }
  });
  const tmp = temp.filter(item => !item.isAWSperre);
  return tmp;
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SAVE_AUFTRAG:
      return {
        ...state,
      };
    case ActionTypes.SET_ADRESSE: {
      const [value, fieldName, addressType] = [
        payload.value,
        payload.fieldName,
        payload.addressType,
      ];
      const temp = state.adressen.map(adresse => {
        if (adresse.typ === addressType) {
          if (fieldName === 'lkz') {
            const tmpAdresse = {
              ...adresse,
              land: value,
            };
            tmpAdresse.lkz = value?.lkz;
            return tmpAdresse;
          }
          return { ...adresse, [fieldName]: value };
        }

        return adresse;
      });
      const set =
        temp.filter(adr => adr.typ === ABWEICHENDE_BELADESTELLE && adr.id)
          .length > 0;
      const setneutral =
        temp.filter(adr => adr.typ === NEUTRALE_ABSENDERADRESSE && adr.id)
          .length > 0;
      return {
        ...state,
        adressen: temp,
        isAbweichendeBeladeAdresse: set && !setneutral,
        isNeutralerAbsenderAdresse: setneutral,
      };
    }

    case ActionTypes.SWITCH_TO_SEARCH:
      const [neueAdresse, adresseTyp] = [
        payload.neueAdresse,
        payload.adresseTyp,
      ];
      payload.neueAdresse.typ = adresseTyp;
      return {
        ...state,
        adressen: replaceAdresseByTyp(state.adressen, neueAdresse, adresseTyp),
      };

    case ActionTypes.SET_AUFTRAG_ID:
      return {
        ...state,
        id: payload,
      };

    case ActionTypes.SET_ABWEICHENDE_BELADUNG:
      return {
        ...state,
        abweichendeBeladung: payload,
      };

    case ActionTypes.SET_IS_ABWEICHENDE_BELADEADRESSE:
      return {
        ...state,
        isAbweichendeBeladeAdresse: payload,
      };

    case ActionTypes.SET_AUFTRAG_KOPIE_ID:
      return {
        ...state,
        copyId: payload,
      };
    case ActionTypes.SET_VORLAGE_AUFTRAG_ID:
      return {
        ...state,
        vorlageAuftragId: payload,
      };
    case ActionTypes.GET_ABSENDERADRESSE_BY_MANDANT:
      if (
        // absender adresse des mandantes soll nur gesetzt werden wenn:
        (!state.copyId &&
          !state.vorlageAuftragId &&
          findAdresseByTyp(state.adressen, 'versender').id === null) || // es keine kopie oder vorlage ist oder während der Erfassung ein neuer Absender angelegt wird
        (state.vorlageAuftragId && // oder wenn es eine Vorlage ist und es gibt noch keinen vorbelegten Versender.
          findAdresseByTyp(state.adressen, 'versender').name === '')
      ) {
        const tmpAdressen = [...state.adressen];
        const filteredAdressen = tmpAdressen.filter(
          adresse => adresse.typ != VERSENDER
        );
        payload.typ = VERSENDER;
        return {
          ...state,
          adressen: [...filteredAdressen, payload],
        };
      } else {
        return state;
      }

    case ActionTypes.SET_BELADEDATUM:
      return {
        ...state,
        beladedatum: isoDateToDate(payload),
      };

    case ActionTypes.SET_DATUM_GEANDERT:
      return {
        ...state,
        datumgeaendert: isoDateToDate(payload),
      };

    case ActionTypes.SET_BELADEZEIT_VON:
      return {
        ...state,
        beladezeitVon: payload,
      };

    case ActionTypes.SET_BELADEZEIT_BIS:
      return {
        ...state,
        beladezeitBis: payload,
      };

    case ActionTypes.SET_EMPFAENGERREFERENZ:
      return {
        ...state,
        empfaengerreferenz: payload,
      };
    case ActionTypes.SET_AUFTRAG_FIELD: {
      const [value, fieldName] = [payload.value, payload.fieldName];
      return {
        ...state,
        [fieldName]: value,
      };
    }

    case ActionTypes.SET_ENTLADEDATUM:
      return {
        ...state,
        entladedatum: isoDateToDate(payload),
      };

    case ActionTypes.SET_ENTLADEZEIT_VON:
      return {
        ...state,
        entladezeitVon: payload,
      };

    case ActionTypes.SET_ENTLADEZEIT_BIS:
      return {
        ...state,
        entladezeitBis: payload,
      };

    case ActionTypes.SET_ABSENDERREFERENZ:
      return {
        ...state,
        absenderreferenz: payload,
      };

    case ActionTypes.RESET_AUFTRAGSERFASSUNG:
      return {
        ...state,
        adressen: initialState.adressen,
        currentServices: getServiceInitialListe(
          (payload as ConfigModel).customServices
        ),
        currentZusLademittel: initialState.currentZusLademittel,
        resetToggle: !state.resetToggle,
        suchvorschlaege: initialState.suchvorschlaege,
        id: initialState.id,
        copyId: initialState.copyId,
        spedeigennr: initialState.spedeigennr,
        currentAuftragpos: initialState.currentAuftragpos,
        terminkennzeichen: initialState.terminkennzeichen,
        zustellkennzeichen: initialState.zustellkennzeichen,
        anlieferkennzeichen: initialState.anlieferkennzeichen,
        datum: initialState.datum,
        beladedatum: (payload as ConfigModel).isBeladedatumVorbelegen
          ? initialState.beladedatum
          : '',
        beladezeitVon: initialState.beladezeitVon,
        beladezeitBis: initialState.beladezeitBis,
        empfaengerreferenz: initialState.empfaengerreferenz,
        partnerreferenz: initialState.partnerreferenz,
        entladedatum: (payload as ConfigModel).isEntladedatumVorbelegen
          ? initialState.entladedatum
          : '',
        entladezeitVon: initialState.entladezeitVon,
        entladezeitBis: initialState.entladezeitBis,
        absenderreferenz: initialState.absenderreferenz,
        mitGefahrguetern: initialState.mitGefahrguetern,
        frankatur: initialState.frankatur,
        verkehrsart: (payload as ConfigModel).isVerkehrsartPflichtfeld
          ? initialState.verkehrsart
          : -1,
        metrokennung: initialState.metrokennung,
        sperrigkeit: initialState.sperrigkeit,
        status: initialState.status,
        tauschpaletteA: initialState.tauschpaletteA,
        tauschpaletteB: initialState.tauschpaletteB,
        tauschpaletteR: initialState.tauschpaletteR,
        tauschpaletteY: initialState.tauschpaletteY,
        hinweis: initialState.hinweis,
        dispohinweis: initialState.dispohinweis,
        zollvermerk: initialState.zollvermerk,
        iban: initialState.iban,
        bic: initialState.bic,
        nachnahmeBetrag: initialState.nachnahmeBetrag,
        nachnahmeWaehrung: initialState.nachnahmeWaehrung,
        abtragen: initialState.abtragen,
        lenkeravis: initialState.lenkeravis,
        myDelivery: initialState.myDelivery,
        adv3: initialState.adv3,
        vorlageAuftragId: undefined,
        isCreateAbsender: initialState.isCreateAbsender,
        isCreateEmpfaenger: initialState.isCreateEmpfaenger,
        kf_id: initialState.kf_id,
        abweichendeBeladung: initialState.abweichendeBeladung,
        isAbweichendeBeladeAdresse: initialState.isAbweichendeBeladeAdresse,
        spotpreisnr: initialState.spotpreisnr,
        erfasser: initialState.erfasser,
        aenderer: initialState.aenderer,
        datumErfasst: initialState.datumErfasst,
        datumgeaendert: initialState.datumgeaendert,
      };

    case ActionTypes.SET_CURRENT_AUFTRAGPOS:
      return {
        ...state,
        currentAuftragpos: payload,
      };

    case ActionTypes.SET_CURRENT_AUFTRAGSGEFAHRGUETER:
      const [auftragsgefahrgueter, auftragsPosRowIndex] = [
        payload.auftragsgefahrgueter,
        payload.auftragsPosRowIndex,
      ];

      const auftragspos = [...state.currentAuftragpos] as Auftragsposition[];
      const selectedAuftragspos = {
        ...(state.currentAuftragpos[auftragsPosRowIndex] as Auftragsposition),
      };
      selectedAuftragspos.auftragsgefahrgueter = auftragsgefahrgueter;
      auftragspos[auftragsPosRowIndex] = selectedAuftragspos;
      return {
        ...state,
        currentAuftragpos: auftragspos,
      };

    case ActionTypes.SET_CURRENT_ZUSLADEMITTEL:
      return {
        ...state,
        currentZusLademittel: payload,
      };

    case ActionTypes.SET_CURRENT_ZUSTELLKENNZEICHEN:
      return {
        ...state,
        zustellkennzeichen: payload,
      };

    case ActionTypes.SET_CURRENT_ANLIEFERKENNZEICHEN:
      return {
        ...state,
        anlieferkennzeichen: payload,
      };

    case ActionTypes.GET_DEFAULT_SERVICES: {
      const services = payload.map((service: ServiceModel) => {
        return {
          ...service,
          elementId: service.id,
        };
      });
      return {
        ...state,
        currentServices: services,
      };
    }
    case ActionTypes.SET_CURRENT_SERVICES: {
      return {
        ...state,
        currentServices: payload,
      };
    }
    case ActionTypes.SET_MIT_GEFAHRGUETERN: {
      return {
        ...state,
        mitGefahrguetern: payload.mitGefahrguetern,
      };
    }

    case ActionTypes.GET_AUFTRAG: {
      const auftrag: Auftrag = payload.auftrag;
      const config: ConfigModel = payload.config;

      const newAuftragState = copyAuftragState(state, auftrag, config);
      return {
        ...state,
        ...newAuftragState,
      };
    }

    case ActionTypes.COPY_AUFTRAG: {
      const auftrag: Auftrag = payload.auftrag;
      const config: ConfigModel = payload.config;
      const newAuftragState = copyAuftragState(state, auftrag, config);
      newAuftragState.datum = new Date().toISOString();
      delete newAuftragState.id;
      delete newAuftragState.spedeigennr;
      delete newAuftragState.status;
      delete newAuftragState.partnerreferenz;
      delete newAuftragState.kf_id;
      delete newAuftragState.spotpreisnr;

      newAuftragState.currentAuftragpos?.forEach(pos => {
        delete pos.id;
        delete pos.auftragId;
      });
      return {
        ...state,
        ...newAuftragState,
      };
    }

    case ActionTypes.GET_AUFTRAG_ID: {
      return {
        ...state,
        id: payload,
      };
    }
    case ActionTypes.GET_BERECHNTEILE: {
      return {
        ...state,
        berechnteile: payload,
      };
    }

    case ActionTypes.GET_AUFTRAG_SERVICES: {
      return {
        ...state,
        defaultAuftragServices: payload,
      };
    }
    case ActionTypes.GET_ABWEICHENDE_BELADUNG: {
      return {
        ...state,
        abweichendeBeladung: payload,
      };
    }

    case ActionTypes.GET_IS_ABWEICHENDE_BELADEADRESSE: {
      return {
        ...state,
        isAbweichendeBeladeAdresse: payload,
      };
    }

    case ActionTypes.GET_ADRESSEN:
    case ActionTypes.GET_ADRESSEN_BY_NAME_OR_MATCHCODE:
    case ActionTypes.SEARCH_LAENDER:
    case ActionTypes.GET_ORTE:
    case ActionTypes.GET_FAHRZEUGE:
    case ActionTypes.SEARCH_VERPACKUNGEN:
    case ActionTypes.SEARCH_GEFAHRGUTKLASSEN:
    case ActionTypes.SEARCH_GEFAHRGUTKLASSEN_UNNR:
      return {
        ...state,
        suchvorschlaege: payload,
      };
    case ActionTypes.CLEAR_SUCHVORSCHLAEGE:
      return {
        ...state,
        suchvorschlaege: [],
      };
    case ActionTypes.SET_TERMINKENNZEICHEN: {
      return {
        ...state,
        terminkennzeichen: payload,
      };
    }
    case ActionTypes.SET_FRANKATUR: {
      return {
        ...state,
        frankatur: payload,
      };
    }
    case ActionTypes.SET_VERKEHRSART: {
      return {
        ...state,
        verkehrsart: payload,
      };
    }
    case ActionTypes.SET_METROKENNUNG: {
      return {
        ...state,
        metrokennung: payload,
      };
    }
    case ActionTypes.SET_SPERRIGKEIT: {
      return {
        ...state,
        sperrigkeit: payload,
      };
    }
    case ActionTypes.SET_ZUSTELLKENNZEICHEN: {
      return {
        ...state,
        zustellkennzeichen: payload,
      };
    }
    case ActionTypes.SET_ANLIEFERKENNZEICHEN: {
      return {
        ...state,
        anlieferkennzeichen: payload,
      };
    }
    case ActionTypes.SET_IBAN: {
      return {
        ...state,
        iban: payload,
      };
    }
    case ActionTypes.SET_BIC: {
      return {
        ...state,
        bic: payload,
      };
    }
    case ActionTypes.SET_NACHNAHMEBETRAG: {
      return {
        ...state,
        nachnahmeBetrag: payload,
      };
    }
    case ActionTypes.SET_NACHNAHMEBETRAG_WAEHRUNG: {
      return {
        ...state,
        nachnahmeWaehrung: payload,
      };
    }
    case ActionTypes.SET_TAUSCH_A: {
      return {
        ...state,
        tauschpaletteA: payload,
      };
    }
    case ActionTypes.SET_TAUSCH_B: {
      return {
        ...state,
        tauschpaletteB: payload,
      };
    }
    case ActionTypes.SET_TAUSCH_R: {
      return {
        ...state,
        tauschpaletteR: payload,
      };
    }
    case ActionTypes.SET_TAUSCH_Y: {
      return {
        ...state,
        tauschpaletteY: payload,
      };
    }
    case ActionTypes.SET_HINWEIS: {
      return {
        ...state,
        hinweis: payload,
      };
    }
    case ActionTypes.SET_DISPOHINWEIS: {
      return {
        ...state,
        dispohinweis: payload,
      };
    }
    case ActionTypes.SET_ZOLLVERMERK: {
      return {
        ...state,
        zollvermerk: payload,
      };
    }
    case ActionTypes.SET_SPOTPREISNR: {
      return { ...state, spotpreisnr: payload };
    }

    case ActionTypes.SET_ERFASSER: {
      return { ...state, erfasser: payload };
    }

    case ActionTypes.SET_AENDERER: {
      return { ...state, aenderer: payload };
    }

    case ActionTypes.GET_CURRENT_BENUTZER: {
      return { ...state, currentBenutzer: payload };
    }

    case ActionTypes.GET_AUFTRAG_SERVICES: {
      return { ...state, defaultAuftragServices: payload };
    }
    case ActionTypes.SET_AUFTRAG_SERVICES: {
      return { ...state, defaultAuftragServices: payload };
    }

    default:
      return state;
  }
}
// kopiert den Auftragsstate beim Laden eines Auftrages (nicht! Auftrag kopieren)
const copyAuftragState = (
  state: StateModel_Auftragserfassung,
  auftrag: Auftrag,
  config: ConfigModel
) => {
  const auftragModel = {
    id: auftrag.id,
    adressen: [
      addAdresseTypToAdresse(
        ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER,
        auftrag.rechnungsempfaengerAdresse ?? emptyAdresse
      ),
      addAdresseTypToAdresse(
        ABWEICHENDE_ENTLADESTELLE,
        auftrag.abweichendeEmpfaengerAdresse ?? emptyAdresse
      ),
      addAdresseTypToAdresse(
        NACHNAHME_EMPFAENGER,
        auftrag.nachnahmeempfaengerAdresse ?? emptyAdresse
      ),
      addAdresseTypToAdresse(
        ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER,
        auftrag.abweichendeRechnungsempfaengerAdresse ?? emptyAdresse
      ),
      addAdresseTypToAdresse(
        ABWEICHENDE_BELADESTELLE,
        auftrag.abweichendeAbholerAdresse ?? emptyAdresse
      ),
      addAdresseTypToAdresse(
        NEUTRALE_ABSENDERADRESSE,
        auftrag.neutralerAbsenderAdresse ?? emptyAdresse
      ),
      addAdresseTypToAdresse(EMPFAENGER, auftrag.empfaengerAdresse),
      addAdresseTypToAdresse(VERSENDER, auftrag.absenderAdresse),
    ],
    spedeigennr: auftrag.spedeigennr,
    datum: auftrag.datum,
    beladedatum: isoDateToDate(auftrag.abholDatumVon),
    beladezeitVon: isoDateToTime(auftrag.abholDatumVon),
    beladezeitBis: isoDateToTime(auftrag.abholDatumBis),
    empfaengerreferenz: auftrag.empfaengerReferenz,
    partnerreferenz: auftrag.partnerReferenz,
    entladedatum: isoDateToDate(auftrag.zustellDatumVon),
    entladezeitVon: isoDateToTime(auftrag.zustellDatumVon),
    entladezeitBis: isoDateToTime(auftrag.zustellDatumBis),
    absenderreferenz: auftrag.spedfremdnr,
    terminkennzeichen: auftrag.terminkennzeichen?.id,
    zustellkennzeichen: auftrag.zustellkennzeichen?.id,
    anlieferkennzeichen: auftrag.anlieferkennzeichen?.id,
    currentZusLademittel: auftrag.auftragZusLademittel,
    abweichendeBeladung: auftrag.abweichendeBeladung,
    neutralerAbsenderAdresse: auftrag.neutralerAbsenderAdresse,
    isAbweichendeBeladeAdresse: isAbwBeladeAdresseSet(auftrag),
    currentAuftragpos: auftragsPositionenToAuftragsPositionenModel(
      auftrag.auftragspositionen
    ),
    frankatur: auftrag.frankatur?.id,
    verkehrsart: auftrag.verkehrsart?.id,
    metrokennung: auftrag.metrokennung?.id,
    sperrigkeit: auftrag.sperrigkeit?.id,
    iban: auftrag.iban,
    bic: auftrag.bic,
    nachnahmeBetrag: auftrag.nachnahmeBetrag,
    nachnahmeWaehrung: auftrag.nachnahmeWaehrung,
    status: auftrag.status,
    tauschpaletteA: auftrag.tauschpaletteA,
    tauschpaletteB: auftrag.tauschpaletteB,
    tauschpaletteR: auftrag.tauschpaletteR,
    tauschpaletteY: auftrag.tauschpaletteY,
    mitGefahrguetern: auftrag.mitGefahrguetern,
    lenkeravis: auftrag.lenkeravis,
    abtragen: auftrag.abtragen,
    myDelivery: auftrag.myDelivery,
    adv3: auftrag.adv3,
    hinweis: auftrag.hinweis,
    dispohinweis: auftrag.dispohinweis,
    zollvermerk: auftrag.zollvermerk,
    currentServices: createServices(state.currentServices, auftrag),
    mandant: auftrag.mandant,
    kf_id: auftrag.kalkulationsFolgeId,
    spotpreisnr: auftrag.spotpreisnr,
    erfasser: auftrag.erfasser,
    aenderer: auftrag.aenderer,
    datumgeaendert: auftrag.datumgeaendert,
    auftragServices: auftrag.auftragServices,
  };

  return auftragModel;
};

const auftragsPositionenToAuftragsPositionenModel = (
  auftragpositionen?: Auftragsposition[]
): AuftragPositionModel[] => {
  let positionenModel: AuftragPositionModel[] = [];
  if (auftragpositionen) {
    positionenModel = auftragpositionen.map(pos => {
      return {
        ...pos,
        verpackung: toSelectOption(pos.verpackung, 'kurzBezeichnung'),
        lademittel: toSelectOption(pos.lademittel, 'kurzBezeichnung'),
        verpackungseinheit: toSelectOption(pos.verpackungseinheit, 'name'),
        auftragsgefahrgueter: pos.auftragsgefahrgueter?.map(
          auftragsgefahrgut => {
            return {
              ...auftragsgefahrgut,
              nettoGewicht: auftragsgefahrgut?.nettoGewicht,
              liter: auftragsgefahrgut?.liter,
              gefahrgutausloeser: auftragsgefahrgut?.gefahrgutausloeser,
              gefahrgutUnnr: auftragsgefahrgut?.gefahrgutklasse,
              gefahrgutklasse: {
                ...auftragsgefahrgut?.gefahrgutklasse,
                abfall: auftragsgefahrgut?.gefahrgutklasse?.abfall,
                begrenztemenge:
                  auftragsgefahrgut?.gefahrgutklasse?.begrenztemenge,
                umweltgefaehrdend:
                  auftragsgefahrgut?.gefahrgutklasse?.umweltgefaehrdend,
                sondervorschrift:
                  auftragsgefahrgut?.gefahrgutklasse?.sondervorschrift,
                klasse: auftragsgefahrgut?.gefahrgutklasse?.klasse,
                klassifizierung:
                  auftragsgefahrgut?.gefahrgutklasse?.klassifizierung,
                gefahrzettel: auftragsgefahrgut?.gefahrgutklasse?.gefahrzettel,
                verpackungscode:
                  auftragsgefahrgut?.gefahrgutklasse?.verpackungscode,
                version: auftragsgefahrgut?.gefahrgutklasse?.version,
              },
            };
          }
        ),
      };
    });
  }
  return positionenModel;
};
const isAbwBeladeAdresseSet = (auftrag: Auftrag) => {
  if (auftrag.abweichendeAbholerAdresse) return true;
  return false;
};
